@import "../../theme/global";

lar-list-item {
  background-color: $background-color-step-100 !important;
  color: $text-color !important;
}

.circle {
  background-color: $background-color-step-200 !important;
  border-radius: 50%;
  display: inline-block;
  padding: .5rem;
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
}

.circle lar-icon {
  display: block;
  width: 100%;
  height: 100%;
}
h4 {
  margin: 0;
  padding: 0;

  lar-badge {
    margin-top: .2rem;
    margin-right: .3rem;
    font-weight: normal;
  }
}
lar-button {
  --lar-button-font-size-small: .95rem;
  --lar-button-padding-top-small: .4rem;
  --lar-button-padding-bottom-small: .4rem;
  --lar-button-padding-left-small: .4rem;
  --lar-button-padding-right-small: .4rem;
}

